export const ROUTES = {
  CARD: '/',
};

export const PION_TYPES = {
  BRAND: 'brand',
  PDF: 'pdf',
  RECEIPT: 'receipt',
  NOTE: 'note',
  PHOTO: 'photo',
  URL: 'url',
  YOUTUBE: 'youtube',
  TYPE_PLATE: 'typePlate',
  CARD: 'card',
  ACTION: 'action',
  PENDING: 'pending',
  TIP: 'tip',
  MANUAL: 'manual',
};

export const LANGUAGES = {
  EN: 'en',
  SV: 'sv',
};

export const KEYBOARD_KEYS = {
  ENTER: {
    KEY: 'Enter',
    CODE: 13,
  },
};

export const URL_OF_ICONS_WEB_FOLDER_S3_BUCKET =
  'https://homer-assets.s3.eu-west-1.amazonaws.com/icons_web/';
